export const ADSBehaviour = {
  CLOSEWIDGET: 'close-widget',
  CLOSEYEAR: 'close-year',
  SELECTDAY: 'select-day',
  SELECTMONTH: 'select-month',
  SELECTYEAR: 'select-year',
  SHOWWIDGET: 'show-widget',
  SHOWYEAR: 'show-year',
  TEXTCHANGE: 'text-change',
  OK: 'ok',
  CANCEL: 'cancel',
  CONFIRMATION: 'confirmation',
};
